import React, { Component } from 'react';
import {CardColumns, CardDeck} from 'reactstrap';

import Feature from '../../../../components/feature/Feature';
import './LibshareFeatures.scss';

const featureGroups = require('./LibshareFeatures.json');

class LibshareFeatures extends Component {
    render() {
        return (
            <div className='libshare-features-container'>
                            <CardDeck>
                {
                    featureGroups.map(group => {
                        return (
                                        group.features.map(feature => {
                                            let featureFolder = feature.folder ? ('./' + feature.folder + '/') : './';
                                            let images = feature.images && feature.images.map(image => {
                                                return { src: require(featureFolder + image) };
                                            });

                                            let thumbnail = feature.thumbnail && require(featureFolder + feature.thumbnail);
                                            
                                            return <Feature
                                                key={feature.title}
                                                title={feature.title}
                                                description={feature.description}
                                                thumbnail={thumbnail}
                                                images={images}
                                                moreInfoUrl={feature.moreInfoUrl}
                                            />
                                        })
                        )
                    })
                }
                            </CardDeck>
            </div>
        );
    }
}

export default LibshareFeatures;


// WEBPACK FOOTER //
// ./src/pages/products/libshare/features/LibshareFeatures.jsx